import { LegalLayout } from "../components/LegalLayout";
import { PRIVACY } from "../data/legal";

export default function Privacy() {
  return (
    <LegalLayout
      doc={PRIVACY}
      path="/privacy"
      seoTitle="Privacy Policy | ZasyaOnline"
      seoDescription="How ZasyaOnline collects, uses, protects and shares information across its websites and the My Bantu application, including cookies, third-party sharing and children's privacy."
      testId="privacy-page"
    />
  );
}
